import SidebarLayout from '../../components/SidebarLayout';
import NoteReferralForm from '../../components/sections/MTSS/NoteReferralForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function NoteReferral() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-note-referral');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AccessWrapper
      allowedGroups={[
        'teacher',
        'mtss_member',
        'mtss_supervisor',
        'mtss_admin',
        'district_admin',
      ]}
    >
      <div>
        <SidebarLayout
          propComponents={<NoteReferralForm />}
          heading={'Add Note/Referral'}
        />
      </div>
    </AccessWrapper>
  );
}
